import React, { useEffect } from 'react'

import { useNavigation } from '@react-navigation/native'
import { B6, colors, SH4, XStack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import ArrowRight from '@zet/design-system/svg/ArrowRight'
import { useUserContext } from '@zet/feature-user'

import { useGetDsaList } from '../../api/login/hooks'
import { i18n } from '../../localization'
import CompanyLinedWhite from '../../svg/CompanyLinedWhite'

const DsaInformation = () => {
  const navigation = useNavigation()
  const { data } = useUserContext()
  const { refetch, data: dsaList } = useGetDsaList()

  useEffect(() => {
    refetch()
  }, [refetch])

  if (!dsaList?.length) return <></>

  const onPress = () => {
    if (dsaList?.length > 1) {
      navigation.navigate('MultipleAccount', {
        handleBack: true,
      })
    }
  }

  return (
    <Pressable
      className="flex-row items-center justify-between px-3 py-2"
      style={{ backgroundColor: colors.tertiary[20] }}
      onPress={onPress}
      disabled={dsaList?.length < 2}
    >
      <XStack className="flex-1 justify-between px-2 py-2">
        <XStack>
          <CompanyLinedWhite />
          <B6 className="ml-2" style={{ color: colors.primary[10] }}>
            {i18n.t('botomTab.partOf')}
            <SH4>{data?.companyName}</SH4>
          </B6>
        </XStack>
        {dsaList?.length > 1 && <ArrowRight color={colors.neutral.white100} />}
      </XStack>
    </Pressable>
  )
}

export { DsaInformation }
